import React, { Component } from 'react';
import withUser from '../../common/withUser';
import withGoBack from '../../common/withGoBack';
import Bugsnag from '../../helpers/bugsnag';

class EnterProductNoManually extends Component {
  _onOK = async () => {
    const { onOK } = this.props;
    try {
      onOK();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onGoBack = () => {
    const { goBack, setGoBack } = this.props;
    goBack.push(window.location.pathname);
    setGoBack(goBack);
  }

  render() {
    return (
      <div
        className="modal fade theme-modal" id="enterProductNoManuallyModal"
        tabIndex="-1" aria-labelledby="enterProductNoManuallyModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-sm">
          <div className="modal-content">
            <div className="modal-body">
              <p>Product number cannot be determined from barcode.
                Enter product number manually.
              </p>
            </div>
            <div className="modal-footer">
              <div className="row">
                <div className="col-12">
                  <button
                    type="button" className="btn btn-link w-100"
                    style={{ color: 'black', padding: '0px' }}
                    data-bs-dismiss="modal"
                    onClick={this._onOK}
                  >
                    OK
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withGoBack(withUser(EnterProductNoManually));
